// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__fw6eB","info":"PatientInfo_info__Pjfsu"};